import React from "react";
import { PageHeader, StatCard, Pill, Btn } from "@/components/kit";
import { Shield } from "@/components/Logo";
import { HardHat, Wallet, PhoneCall, Bot } from "lucide-react";

const COLORS = [
  ["Primary Navy", "#0B2545"], ["Accent Red", "#C8102E"], ["Steel Gray", "#4A5568"],
  ["Cloud BG", "#F5F7FA"], ["White", "#FFFFFF"], ["Success", "#1B7F3B"],
  ["Warning", "#D97706"], ["Danger", "#B42318"],
];

export default function StyleGuide() {
  return (
    <div className="space-y-8">
      <PageHeader title="Style Guide" subtitle="Design tokens & components so future work stays on-brand — Built For You" />

      <section className="mb-card p-6">
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Logo</h3>
        <div className="flex items-center gap-8 bg-navy rounded-xl p-6"><Shield size={48} withText /><Shield size={40} /></div>
      </section>

      <section className="mb-card p-6">
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Color Tokens</h3>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {COLORS.map(([name, hex]) => (
            <div key={hex} data-testid={`color-${hex}`}>
              <div className="h-20 rounded-xl border border-slate-200" style={{ background: hex }} />
              <div className="mt-2 text-sm font-semibold text-navy">{name}</div>
              <div className="font-num text-xs text-slate-400">{hex}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="mb-card p-6">
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Typography</h3>
        <div className="space-y-3">
          <div><span className="text-xs text-slate-400 uppercase">Display · Barlow Condensed</span><div className="font-display text-4xl font-extrabold uppercase text-navy">Built For You</div></div>
          <div><span className="text-xs text-slate-400 uppercase">Body · Inter</span><p className="text-base text-slate-700">The operating system for running the entire company from lead to cash.</p></div>
          <div><span className="text-xs text-slate-400 uppercase">Numeric · JetBrains Mono</span><div className="font-num text-2xl font-bold text-navy">$187,400.00</div></div>
        </div>
      </section>

      <section className="mb-card p-6">
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Buttons</h3>
        <div className="flex flex-wrap gap-3"><Btn variant="navy">Primary Navy</Btn><Btn variant="red">Accent Red</Btn><Btn variant="ghost">Secondary</Btn></div>
      </section>

      <section className="mb-card p-6">
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Pills & Badges</h3>
        <div className="flex flex-wrap gap-2">
          {["slate", "navy", "red", "green", "amber", "danger", "blue"].map((t) => <Pill key={t} tone={t}>{t}</Pill>)}
        </div>
      </section>

      <section>
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Stat Cards</h3>
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          <StatCard label="Jobs Today" value="3" icon={HardHat} />
          <StatCard label="Available Cash" value="$184,200" icon={Wallet} tone="green" />
          <StatCard label="Calls" value="27" icon={PhoneCall} tone="navy" />
          <StatCard label="AI Answers" value="142" icon={Bot} tone="red" />
        </div>
      </section>

      <section className="mb-card p-6">
        <h3 className="font-display text-xl font-bold uppercase text-navy mb-4">Motion</h3>
        <p className="text-sm text-slate-600">150–200ms ease-out transitions · subtle spring scale-in on modals · active press translate-y. No cutesy bounce.</p>
      </section>
    </div>
  );
}
